module.exports = __webpack_public_path__ + "static/media/cursor_ai.cfb342e1.png";